export const adsQuestions = [
  {
    question: "What are the Banner Sizes?",
    answer:
      "As you can see on the right and on the bottom, EasyDuct offers three specific sizes and locations to choose from. The one that is right for you depends on your budget, lead-generation goals, and timeframes.",
  },
  {
    question: "Are there discounts for doing advertising more frequently?",
    answer:
      "Yes, you can buy 1000 impressions per week, month, or quarter. Weekly runs about half as much as quarterly. With monthly fitting right between those two.",
  },
  {
    question:
      "Are there discounts for advertising over longer periods of time?",
    answer:
      "For sure. You can buy monthly, quarterly or yearly. With the same discount schedule as above.",
  },
  {
    question: "Do you offer creative ad services?",
    answer:
      "Yes. We are a full-service shop. We will brainstorm, design, develop, and run your Ads to stand out and be irresistible to your target audience.",
  },
];
